"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const FiltersContainer_1 = __importDefault(require("./FiltersContainer"));
exports.default = FiltersContainer_1.default;
//# sourceMappingURL=index.js.map